<script setup lang="ts">
import type { AppState } from '~/stores/AppStore'

defineProps({
  data: {
    type: Object as PropType<AppState>,
    default: () => {}
  }
})

const year: number = new Date().getFullYear()
const appConfig = useAppConfig()
</script>

<template>
  <footer class="py-8 lg:py-10">
    <div class="container grid grid-cols-12">
      <div class="col-span-full mb-9 lg:col-span-6 lg:mb-15">
        <SiteMap :data="data.allMenuItems" />
      </div>
      <div class="col-span-full mb-24 lg:order-3 lg:mb-44">
        <FooterMenuList :data="data.allFooterMenuItems" />
      </div>
      <div class="col-span-full lg:order-2 lg:col-span-6">
        <SocialLinks
          class="mb-8 mix-blend-difference lg:mx-auto lg:mr-0"
          :data="appConfig.social"
        />
      </div>
      <div class="col-span-full lg:order-4 lg:col-span-6">
        <small class="whitespace-nowrap lg:text-lg lg:font-bold"
          >©{{ year }} Atlas Creative. All Rights Reserved.</small
        >
      </div>
      <div class="col-span-full lg:order-5 lg:col-span-6">
        <FooterLinks :data="data.allFooterLinks" class="mt-5 lg:mt-0" />
      </div>
    </div>
  </footer>
</template>
